var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 389.3 181.5",
    style: {
      enableBackground: "new 0 0 389.3 181.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D3161A;}\n\t.st1{fill:#125AA8;}\n\t.st2{fill:#F29716;}\n\t.st3{fill:#66B630;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.7,50h20.8v113H72.7v-39c-4,3.9-8.1,6.6-12.2,8.3c-4.1,1.7-8.5,2.5-13.2,2.5c-10.7,0-19.9-4.1-27.7-12.4 c-7.8-8.3-11.7-18.6-11.7-30.9c0-12.8,3.8-23.2,11.3-31.4c7.5-8.2,16.7-12.2,27.5-12.2c5,0,9.6,0.9,14,2.8 c4.4,1.9,8.4,4.7,12.1,8.4V50z M50.9,67c-6.4,0-11.7,2.3-16,6.8c-4.2,4.5-6.4,10.4-6.4,17.4c0,7.1,2.2,13,6.5,17.6 c4.3,4.6,9.6,6.9,15.9,6.9c6.5,0,11.9-2.3,16.2-6.8c4.3-4.5,6.4-10.5,6.4-17.8c0-7.2-2.1-13-6.4-17.5C62.9,69.2,57.5,67,50.9,67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,50h21v39.8c0,7.8,0.5,13.1,1.6,16.2c1.1,3,2.8,5.4,5.1,7c2.4,1.7,5.3,2.5,8.7,2.5c3.5,0,6.4-0.8,8.8-2.5 c2.4-1.6,4.2-4.1,5.4-7.3c0.9-2.4,1.3-7.5,1.3-15.3V50h20.8v35c0,14.4-1.1,24.3-3.4,29.6c-2.8,6.5-6.9,11.5-12.3,14.9 c-5.4,3.5-12.3,5.2-20.7,5.2c-9.1,0-16.4-2-22-6.1c-5.6-4.1-9.5-9.7-11.8-17c-1.6-5-2.4-14.1-2.4-27.4V50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,50h20.8v82.7h-20.8v-8.7c-4.1,3.9-8.1,6.6-12.2,8.3s-8.5,2.5-13.2,2.5c-10.7,0-19.9-4.1-27.7-12.4 c-7.8-8.3-11.7-18.6-11.7-30.9c0-12.8,3.8-23.2,11.3-31.4c7.5-8.2,16.7-12.2,27.5-12.2c5,0,9.6,0.9,14,2.8 c4.4,1.9,8.4,4.7,12.1,8.4V50z M240.9,67c-6.4,0-11.7,2.3-16,6.8c-4.2,4.5-6.4,10.4-6.4,17.4c0,7.1,2.2,13,6.5,17.6 c4.3,4.6,9.6,6.9,15.9,6.9c6.5,0,11.9-2.3,16.2-6.8c4.3-4.5,6.4-10.5,6.4-17.8c0-7.2-2.1-13-6.4-17.5 C252.9,69.2,247.4,67,240.9,67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,18.1h20.8v114.6h-20.8v-8.7c-4.1,3.9-8.1,6.6-12.2,8.3c-4.1,1.7-8.5,2.5-13.2,2.5c-10.7,0-19.9-4.1-27.7-12.4 s-11.7-18.6-11.7-30.9c0-12.8,3.8-23.2,11.3-31.4c7.5-8.2,16.7-12.2,27.5-12.2c5,0,9.6,0.9,14,2.8c4.4,1.9,8.4,4.7,12.1,8.4V18.1z  M340.5,67c-6.4,0-11.7,2.3-16,6.8c-4.2,4.5-6.4,10.4-6.4,17.4c0,7.1,2.2,13,6.5,17.6c4.3,4.6,9.6,6.9,15.9,6.9 c6.5,0,11.9-2.3,16.2-6.8c4.3-4.5,6.4-10.5,6.4-17.8c0-7.2-2.1-13-6.4-17.5C352.5,69.2,347.1,67,340.5,67z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 142.1,
    className: "st0",
    width: 62.5,
    height: 20.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.6,
    y: 142.1,
    className: "st1",
    width: 62.5,
    height: 20.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.3,
    y: 142.1,
    className: "st2",
    width: 62.5,
    height: 20.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 142.1,
    className: "st3",
    width: 62.5,
    height: 20.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadLogo);
export default __webpack_public_path__ + "static/media/quad-logo.f99108b1b4fddc39b102d1a411c143a8.svg";
export { ForwardRef as ReactComponent };